export default [
  {
    date: "13 Nov 2021",
    totalnumber: "0",
    totalclicked: "0",
    campaignid: "1q2we4",
    type: "SMS",
  },
  {
    date: "13 Nov 2021",
    totalnumber: "0",
    totalclicked: "0",
    campaignid: "1q2we4",
    type: "SMS",
  },
];
